import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Grid } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { ButtonWithLoader, type Field } from '@pbt/pbt-ui-components'

import FeatureToggle from '~/constants/featureToggle'
import { getFeatureToggle } from '~/store/reducers/constants'
import { getConversationById } from '~/store/reducers/conversations'

import CommunicationTemplateInputWithAttachments from '../../template-inputs/CommunicationTemplateInputWithAttachments'

const useStyles = makeStyles(
  (theme) => ({
    addButton: {
      width: 150,
    },
    noteContent: {
      padding: theme.spacing(2, 2, 0),
    },
  }),
  { name: 'InternalNote' },
)

export interface InternalNoteProps {
  conversationId: string
  handleAddNote: () => void
  isLoading: boolean
  messageField: Field
}

const InternalNote = ({
  isLoading,
  messageField,
  handleAddNote,
  conversationId,
}: InternalNoteProps) => {
  const classes = useStyles()
  const conversation = useSelector(getConversationById(conversationId))
  const isCommunicationRightRailEnabled = useSelector(
    getFeatureToggle(FeatureToggle.ENABLE_COMMUNICATIONS_RIGHT_RAIL),
  )
  const { t } = useTranslation(['Common'])

  return (
    <Grid container direction="column">
      <CommunicationTemplateInputWithAttachments
        attachmentMenuPlacement="bottom"
        className={classes.noteContent}
        clientId={conversation?.client}
        eventId={conversation?.eventId}
        field={messageField}
        isChirp={isCommunicationRightRailEnabled}
        minHeight={240}
        patientId={conversation?.patient}
      />
      <Grid container item p={2}>
        <ButtonWithLoader
          className={classes.addButton}
          loading={isLoading}
          onClick={handleAddNote}
        >
          {t('Common:ADD_NOTE')}
        </ButtonWithLoader>
      </Grid>
    </Grid>
  )
}

export default InternalNote
